import { formatTimeIT } from './format.js';

export function resolveMember(members, userId) {
  if (!userId) return null;
  return members?.find((m) => m.user_id === userId) ?? null;
}

export function authorChip(members, userId, updatedAt) {
  const member = resolveMember(members, userId);
  if (!member) return '';
  const time = updatedAt ? formatTimeIT(updatedAt) : '';
  return `
    <span class="author-chip">
      <span class="author-chip__emoji" aria-hidden="true">${member.avatar_emoji ?? '👤'}</span>
      ${member.display_name}${time ? ` · ${time}` : ''}
    </span>
  `;
}
